<template>
<!--  <v-flex class="tables-layout">-->
   <div class="tables-layout">
     <table-layout>
       <template v-slot:title>{{ typeHeader }}별 실적 요약</template>
       <template v-slot:table>
         <statics-table :is-total="true" :params-data="paramsData" :total-data="yearBySumList" />
       </template>
     </table-layout>
     <table-layout>
       <template v-slot:title>대출과목별</template>
       <template v-slot:table>
         <statics-table :is-default="true" :params-data="paramsData" :is-product="true" :default-data="yearByProductList" />
       </template>
     </table-layout>
     <table-layout>
       <template v-slot:title>대출유형별</template>
       <template v-slot:table>
         <statics-table :is-default="true" :params-data="paramsData" :is-loan-type="true" :default-data="yearByLoanTypeList" />
       </template>
     </table-layout>
     <table-layout>
       <template v-slot:title>대출유형별(주담대)</template>
       <template v-slot:table>
         <statics-table :is-default="true" :params-data="paramsData" :is-loan-type-group="true" :default-data="yearByLoanTypeGroupList" />
       </template>
     </table-layout>
   </div>
<!--  </v-flex>-->
</template>
<script>
import TableLayout from "@/common/layout/TableLayout.vue";
import StaticsTable from "@/common/components/StaticsTable.vue";
import _ from "lodash";

export default {
  name: "LoanStaticsDetail",
  components: {StaticsTable, TableLayout},
  props: ["paramsData", "data", "loading"],
  data() {
    return {
      yearBySumList: [],            // 요약
      yearByProductList: [],        // 대출과목별
      yearByLoanTypeList: [],       // 대출유형별
      yearByLoanTypeGroupList: []   // 대출유형별(주담대별)
    }
  },
  computed: {
    typeHeader() {
      if (this.paramsData.type === "Y") return "연도";
      if (this.paramsData.type === "Q") return "분기"
      return "월";
    }
  },
  watch: {
    data(value) {
      if (!_.isEmpty(value)) {
        this.yearBySumList = value.performanceYearBySumList;
        this.yearByProductList = value.performanceYearByProductList;
        this.yearByLoanTypeList = value.performanceYearByLoanTypeList;
        this.yearByLoanTypeGroupList = value.performanceYearByLoanTypeGroupList;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tables-layout {
  height: 60vh;
  max-height: 800px;
  width: 95vw;
  position: relative;
  overflow-y: auto;
}
</style>